import { useQuery } from "@atlassiansox/microscopekit";
import { InstantRunTemplatesQuery } from "../../../graphql";
export var useRecommendedFaults = function () {
    var _a, _b;
    var _c = useQuery(InstantRunTemplatesQuery), data = _c.data, loading = _c.loading;
    var recommendedFaults = (_b = (_a = data === null || data === void 0 ? void 0 : data.instantRunTemplates) === null || _a === void 0 ? void 0 : _a.map(function (template) { return ({
        id: template.id,
        name: template.name,
        mainParameterValue: template.recommendedMainParameterValue,
        description: template.description,
        lastMonthExecutionCount: template.Stats.month
    }); })) !== null && _b !== void 0 ? _b : [];
    return {
        recommendedFaults: recommendedFaults,
        isLoading: loading
    };
};
